import { useEffect, useState } from 'react'
import { company, customerData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'
import { useNavigate } from 'react-router-dom'
import { refreshAccessToken } from '../../../utilities/extensions'
import ReactPixel from 'react-facebook-pixel'

import advanceFundingIcon from '../../../assets/RefundCalculatedIcons/advanceFundingIcon.png'
import prePaidIcon from '../../../assets/RefundCalculatedIcons/prePaidIcon.png'

export function RefundOptions({ applicationId, setInterestAmount, setLienAmount, handleSelectRefundType }) {
  const navigate = useNavigate()
  const [check1, setCheck1] = useState(false)
  const [check2, setCheck2] = useState(false)
  const [preCheck1, setPreCheck1] = useState(false)
  const [qualifies, setQualifies] = useState(false)
  const [checkingQualifies, setCheckingQualifies] = useState(true)
  const [prePaidFee, setPrePaidFee] = useState(0.05)
  const [postPaidFee, setPostPaidFee] = useState(0.20)

  useEffect(() => {
    const handleCheckCustomerQualifies = async () => {
      const checkingQualifiesResponse = await fetch(`${apiURL}/api/checkCustomerQualifies?leadId=${encodeURIComponent(customerData.customerLeadData.leadId)}`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const checkingQualifiesData = await checkingQualifiesResponse.json()
      setCheckingQualifies(false)
      if(checkingQualifiesData.response.error) {
        if(checkingQualifiesData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheckCustomerQualifies() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkingQualifiesData.response.error)
      } else {
        setQualifies(checkingQualifiesData.response.qualifies)
        setInterestAmount(checkingQualifiesData.response.interestAmount)
        setLienAmount(checkingQualifiesData.response.lienAmount)

        if(checkingQualifiesData.response.qualifies && (customerData.customerLeadData.affiliate.affiliateName === 'Bill Hillestad' || customerData.customerLeadData.affiliate.affiliateName === 'RIF Social, LLC') && window.location.hostname === 'myportal.setcpros.com') {
          ReactPixel.init('1582173432356356')
          ReactPixel.trackCustom('Express')
        }
      }
    }

    handleCheckCustomerQualifies()
    window.scrollTo(0,0)
  }, [])

  useEffect(() => {
    if(qualifies) {
      setPrePaidFee(0.29)
      setPostPaidFee(0.29)
    }
  }, [qualifies])

  useEffect(() => {
    document.title = `${company.companyName} | Refund Options`
  }, [])

  return (
    <div className='flex flex-col items-center'>
      {checkingQualifies ? (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Loading Options...</p>
        </div>
      ) : (
        <div className='w-full flex flex-col items-center'>
          <p className='lg:text-xl font-bold'>How would you like to received your refund?</p>
          <div className='w-11/12 h-full flex lg:flex-row flex-col items-stretch justify-center gap-8 mt-4 flex-1 max-sm:mb-10'>
            {qualifies && (
              <div className='w-full flex flex-col items-center flex-1 gap-4'>
                <p className='font-bold text-2xl'>Option 1</p>
                <div className='relative flex flex-col items-center rounded-md shadow-md bg-gray-50 border-4 border-primaryColor flex-1'>
                  <p className='absolute -top-3 left-3 text-white px-2 py-1 rounded-full text-xs bg-primaryColor'>Fastest Option</p>
                  <div className='flex flex-col items-center bg-gray-100 w-full p-4 rounded-md'>
                    <img className='h-14 p-1' src={advanceFundingIcon} />
                    <p className='font-semibold text-xl'>Express Refund</p>
                    <p><span className='font-bold text-2xl'>3-5 days</span> to receive your funds after filling*</p>
                  </div>
                  <div className='w-full flex flex-col gap-6 p-6'>
                    <div>
                      <p className='w-full text-left font-semibold'>Express Refund</p>
                      <p>An advance loan from our partner bank gets you your money faster and pays all tax prep fees.</p>
                    </div>
                    <div className='flex flex-col items-start bg-green-200 w-[95%] p-4 rounded-md self-center'>
                      <p>Pay Today</p>
                      <p className='text-green-600 font-bold text-2xl'>$0</p>
                      <p className='text-gray-500'>Fees deducted from your refund:</p>
                      <ul className='list-disc ml-5 mt-2'>
                        <li>20% Tax Prep Fee (SETC Pros)</li>
                        <li>9% Other Fees</li>
                      </ul>
                    </div>
                    <div className='border-b-2 border-b-gray-300'>
                      <div className='flex flex-row items-center gap-4'>
                        <span className='text-green-500 text-lg'>&#10003;</span>
                        <p>Receive your funds in 3-5 days after filing.</p>
                      </div>
                      <div className='flex flex-row items-center gap-4'>
                        <span className='text-green-500 text-lg'>&#10003;</span>
                        <p>Funds sent directly to you via ACH.</p>
                      </div>
                      <div className='flex flex-row items-center gap-4'>
                        <span className='text-green-500 text-lg'>&#10003;</span>
                        <p>No upfront payment required.</p>
                      </div>
                    </div>
                    <div className='w-full flex flex-col gap-2'>
                      <div onClick={() => setCheck1(!check1)} className='flex flex-row cursor-pointer'>
                        <input
                          type='checkbox'
                          id='checkbox1'
                          checked={check1}
                          onChange={(e) => setCheck1(e.target.checked)}
                          className='mr-2'
                        />
                        <p>I have a U.S. based checking account in my name. This is a requirement for the advance program.</p>
                      </div>
                      <div onClick={() => setCheck2(!check2)} className='flex flex-row cursor-pointer'>
                        <input
                          type='checkbox'
                          id='checkbox1'
                          checked={check2}
                          onChange={(e) => setCheck2(e.target.checked)}
                          className='mr-2'
                        />
                        <p>I agree to Community Bank & Trust WGA's <span onClick={() => window.innerWidth <= 768 ? window.location.href = `${apiURL}/termsAndConditions` : window.open(`${apiURL}/termsAndConditions`, '_blank')} className='underline'>Terms and Conditions</span>.</p>
                      </div>
                    </div>
                    <button
                      className={`w-full mt-auto rounded-lg p-2 text-white ${check1 & check2 ? 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                      disabled={!check1 || !check2}
                      onClick={() => handleSelectRefundType('Advance Funding', 0.29)}
                    >
                      {applicationId ? 'Continue Application' : 'Choose Express Refund'}
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div className='flex flex-col items-center flex-1 gap-4'>
              <p className='font-bold text-2xl'>{qualifies ? 'Option 2' : 'Option 1'}</p>
              <div className='w-full flex flex-col items-center rounded-md shadow-md bg-gray-50 flex-1'>
                <div className='flex flex-col items-center bg-gray-100 w-full p-4'>
                  <img className='h-14 p-1' src={prePaidIcon} />
                  <p className='font-semibold text-xl'>Pre-Paid</p>
                  <p><span className='font-bold text-2xl'>12-15 weeks</span> to receive your funds*</p>
                </div>
                <div className='w-full flex flex-col gap-6 p-6 h-full'>
                  <div>
                    <p className='w-full text-left font-semibold'>Pre-Paid Payment</p>
                    <p>Pay your SETC fee upfront and receive your documents now.</p>
                    {qualifies && (
                      <p>&nbsp;</p>
                    )}
                  </div>
                  <div className='flex flex-col items-start bg-green-200 w-[95%] p-4 rounded-md self-center'>
                    <p>Pay Today</p>
                    {prePaidFee === 0.15 ? (
                      <p className='text-green-600 font-bold text-2xl'>${(customerData.customerLeadData.leadAmount * prePaidFee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                    ) : (
                      <>
                      {!qualifies && (
                        <p className="text-setcg font-bold text-2xl line-through text-gray-500">
                          ${(customerData.customerLeadData.leadAmount * 0.15).toLocaleString('en-US', { 
                            minimumFractionDigits: 2, 
                            maximumFractionDigits: 2 
                          })}
                        </p>
                      )}
                      <p className='text-green-600 font-bold text-2xl'>${(customerData.customerLeadData.leadAmount * prePaidFee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      </>
                    )}
                    <p>&nbsp;</p>
                    {!qualifies && (
                      <p>&nbsp;</p>
                    )}
                    {qualifies ? (
                      <ul className='list-disc ml-5 mt-2'>
                        <li>20% Tax Prep Fee (SETC Pros)</li>
                        <li>9% Other Fees</li>
                      </ul>
                    ) : (
                      <ul className='list-disc ml-5 mt-2'>
                        {prePaidFee === 0.15 ? (
                          <li>{Math.round(prePaidFee * 100)}% Tax Prep Fee (SETC Pros Inc.)</li>
                        ) : (
                          <>
                          <li className="line-through text-gray-500">15% Tax Prep Fee (SETC Pros)</li>
                          <li className="text-green-600 font-semibold">5% Tax Prep Fee (SETC Pros) - <span className="text-red-500">LIMITED TIME Offer!</span></li>
                          </>
                        )}
                      </ul>
                    )}
                  </div>
                  <div className='border-b-2 border-b-gray-300'>
                    <div className='flex flex-row items-center gap-4'>
                      <span className='text-red-500 text-lg'>*</span>
                      <p>Receive your funds in 12-15 weeks.</p>
                    </div>
                    <div className='flex flex-row items-center gap-4'>
                      <span className='text-red-500 text-lg'>*</span>
                      <p>Funds sent directly to you via ACH or Check by IRS.</p>
                    </div>
                    <div className='flex flex-row items-center gap-4'>
                      <span className='text-red-500 text-lg'>*</span>
                      <p>Upfront payment of fee required.</p>
                    </div>
                  </div>
                  {qualifies && (
                    <div className='w-full flex flex-col gap-2'>
                      <div onClick={() => setPreCheck1(!preCheck1)} className='flex flex-row cursor-pointer'>
                        <input
                          type='checkbox'
                          id='checkbox1'
                          checked={preCheck1}
                          onChange={(e) => setPreCheck1(e.target.checked)}
                          className='mr-2'
                        />
                        <p className='max-w-md'>I confirm that I want to wait 12 - 15 weeks for the IRS to process my refund to receive my funds.</p>
                      </div>
                    </div>
                  )}
                  <button
                    disabled={!preCheck1 && qualifies}
                    className={`w-full mt-auto rounded-lg p-2 text-white ${preCheck1 || !qualifies ? 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200' : 'bg-gray-300 cursor-not-allowed'}`}
                    onClick={() => handleSelectRefundType('Pre-Paid', prePaidFee)}
                  >
                    Choose Pre-Paid Refund
                  </button>
                </div>
              </div>
            </div>
            {(!qualifies && (customerData.customerLeadData.leadStage.leadStageId === 'd195503d-081a-4d94-a413-6e02bb83d40c' || customerData.customerLeadData.leadStage.leadStageId === 'f96797f5-64bd-443a-ad49-dc0abed71e07') && customerData.customerLeadData.leadAmount > 500) && (
              <div className='flex flex-col items-center flex-1 gap-4'>
                <p className='font-bold text-2xl'>Option 2</p>
                <div className='flex flex-col items-center rounded-md shadow-md bg-gray-50 flex-1'>
                  <div className='flex flex-col items-center bg-gray-100 w-full p-4'>
                    <p className='font-semibold text-xl'>Post-Paid</p>
                    <p><span className='font-bold text-2xl'>12-15 weeks</span> to receive your funds after filling*</p>
                  </div>
                  <div className='w-full flex flex-col gap-6 p-6 h-full'>
                    <div>
                      <p className='w-full text-left font-semibold'>Post-Paid Payment</p>
                      <p>No payment upfront, and get your SETC documents now.</p>
                    </div>
                    <div className='flex flex-col items-start bg-green-200 w-[95%] p-4 rounded-md self-center'>
                      <p>Pay Today</p>
                      <p className='text-green-600 font-bold text-2xl'>$0</p>
                      <p className='text-gray-500'>Fees deducted from your refund after IRS issues your refund:</p>
                      {qualifies ? (
                        <ul className='list-disc ml-5 mt-2'>
                          <li>20% Tax Prep Fee (SETC Pros)</li>
                          <li>9% Other Fees</li>
                        </ul>
                      ) : (
                        <ul className='list-disc ml-5 mt-2'>
                          <li>{Math.round(postPaidFee * 100)}% Tax Prep Fee (SETC Pros)</li>
                        </ul>
                      )}
                    </div>
                    <div className='border-b-2 border-b-gray-300'>
                      <div className='flex flex-row items-center gap-4'>
                        <span className='text-red-500 text-lg'>*</span>
                        <p>Receive your funds in 12-15 weeks.</p>
                      </div>
                      <div className='flex flex-row items-center gap-4'>
                        <span className='text-red-500 text-lg'>*</span>
                        <p>Funds sent directly to you via ACH or Check by IRS.</p>
                      </div>
                      <div className='flex flex-row items-center gap-4'>
                        <span className='text-red-500 text-lg'>*</span>
                        <p>No upfront payment required.</p>
                      </div>
                    </div>
                    <button
                      className='w-full mt-auto rounded-lg p-2 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white'
                      onClick={() => handleSelectRefundType('Post-Paid', postPaidFee)}
                    >
                      Choose Post-Paid Refund
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <p className='italic text-gray-400 mt-4'>* The times listed are only an average. You may experience shorter or longer timeframes depending on several circumstances.</p>
        </div>
      )}
    </div>
  )
}